import { connect } from 'react-redux';
import SiteAssetMapping from './siteAssetMapping';
import { bindActionCreators } from 'redux';
import {
  getSiteListingForAssetMapping,
  getSiteFilters,
  getLocationChange,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.siteListingAsset,
  siteFilters: state.siteListingReducer.siteFiltersData,
  locationChange: state.siteListingReducer.locationChange
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListingForAssetMapping,
      getSiteFilters,
      getLocationChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteAssetMapping);
